module.exports = __webpack_public_path__ + "img/bg_5.31399f25.png";